import { ADMIN_STATE_KEY } from "~/admin";
import { SETUP_RELEASE_NOTES_DATA_KEY } from "~/admin/setup/release-notes/data/reducer";

const _getModuleState = (state) => state[ADMIN_STATE_KEY][SETUP_RELEASE_NOTES_DATA_KEY];

export const getReleaseNotes = (state: unknown): any => _getModuleState(state).releaseNotes;

export const getLoadingReleaseNotes = (state: unknown): any =>
    _getModuleState(state).loadingReleaseNotes;
